import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect, useRef, useCallback } from 'react';
import isElectron from 'is-electron';
import { twMerge } from 'tailwind-merge';
import BaseInput from 'flow/components/ui-components/BaseInput';
import { IS_UAE_HOST } from 'flow/utils/browser-utils-TW';
import { getAutoLogin } from 'flow/utils/browser-utils';
import SignInHelperDialog from 'flow/components/modals/dialogs/SignInHelperDialog';
import SignInHelperDialogEtisalat from 'flow/components/modals/dialogs/SignInHelperDialogEtisalat';
import Button from './ui-components/Button';
import ExternalSigninButton from 'flow/components/buttons/ExternalSigninButton';
import CancelExternalSigninDialog from 'flow/components/dialogs/CancelExternalSignInDialog';
import { getShouldShowSingleSignOnButton, getHasAnySingleSignOn } from 'flow/utils/brand-utils';
import { SYNC_SOURCE } from 'flow/utils/constants/app-constants';
import DropdownMenuComponent from './ui-components/DropdownMenuComponent';
import { LocalesData } from 'flow/utils/locales-data';
import Socialintegration from 'flow/api/socialintegration';
import useAppContext from 'flow/hooks/useAppContext';
import BrandLogo from './nav/BrandLogo';
import { useAuthService } from 'flow/authservice/useAuthService';
import Loading from './ui-components/Loading';
import { authServiceSignIn } from 'flow/actions/app-actions';
import { useAppDispatch } from 'flow/hooks/useRedux';
import UaePassSignIn from './uae-pass/UaePassSignIn';
import { useUserRegionData } from 'flow/hooks/region-lookup/useUserRegionData';
import { createTypedMap } from 'flow/types/TypedMap';
import UserRegionDropdown from './region-lookup/UserRegionDropdown';
import { isUaePassEnabled } from 'flow/constants/uae-pass/uae-pass-constants';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SignInForm = function SignInForm(_ref) {
  var handleSignIn = _ref.handleSignIn,
    _ref$password = _ref.password,
    password = _ref$password === void 0 ? '' : _ref$password,
    _ref$username = _ref.username,
    username = _ref$username === void 0 ? '' : _ref$username,
    onUsernameChanged = _ref.onUsernameChanged,
    onPasswordChanged = _ref.onPasswordChanged,
    loginData = _ref.loginData,
    passwordUrl = _ref.passwordUrl,
    onLinkClick = _ref.onLinkClick,
    _ref$externalSigninDa = _ref.externalSigninData,
    externalSigninData = _ref$externalSigninDa === void 0 ? createTypedMap() : _ref$externalSigninDa,
    _ref$allowedVersion = _ref.allowedVersion,
    allowedVersion = _ref$allowedVersion === void 0 ? true : _ref$allowedVersion,
    _ref$tooManyInstances = _ref.tooManyInstances,
    tooManyInstances = _ref$tooManyInstances === void 0 ? false : _ref$tooManyInstances,
    _ref$isCtiEmbedded = _ref.isCtiEmbedded,
    isCtiEmbedded = _ref$isCtiEmbedded === void 0 ? false : _ref$isCtiEmbedded,
    _ref$isTeamsEmbedded = _ref.isTeamsEmbedded,
    isTeamsEmbedded = _ref$isTeamsEmbedded === void 0 ? false : _ref$isTeamsEmbedded,
    startGoogleSignIn = _ref.startGoogleSignIn,
    startMicrosoftSignIn = _ref.startMicrosoftSignIn,
    startOidcSignIn = _ref.startOidcSignIn,
    cancelExternalSignIn = _ref.cancelExternalSignIn,
    _ref$showOtherSignInF = _ref.showOtherSignInForm,
    showOtherSignInForm = _ref$showOtherSignInF === void 0 ? false : _ref$showOtherSignInF,
    setShowOtherSignInForm = _ref.setShowOtherSignInForm,
    _ref$enabledOidcSignI = _ref.enabledOidcSignIn,
    enabledOidcSignIn = _ref$enabledOidcSignI === void 0 ? true : _ref$enabledOidcSignI,
    setEnabledOidcSignIn = _ref.setEnabledOidcSignIn,
    _ref$usernameOther = _ref.usernameOther,
    usernameOther = _ref$usernameOther === void 0 ? '' : _ref$usernameOther,
    onUsernameOtherChanged = _ref.onUsernameOtherChanged,
    onLanguageChange = _ref.onLanguageChange;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showHelperDialog = _useState2[0],
    setShowHelperDialog = _useState2[1];
  var usernameRef = useRef(null);
  var usernameOtherRef = useRef(null);
  var focusTimeoutRef = useRef(null);
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pendingSignIn = _useState4[0],
    setPendingSignIn = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    pendOidcUserName = _useState6[0],
    setPendOidcUserName = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isUaePassFlowActive = _useState8[0],
    setIsUaePassFlowActive = _useState8[1];
  var _useAuthService = useAuthService(),
    authLogin = _useAuthService.authLogin,
    isAuthenticated = _useAuthService.isAuthenticated,
    token = _useAuthService.token,
    isAuthLoading = _useAuthService.isAuthLoading,
    isAuthServiceEnabled = _useAuthService.isAuthServiceEnabled;
  var _useUserRegionData = useUserRegionData(),
    isRegionCheckEnabled = _useUserRegionData.isRegionCheckEnabled,
    fetchRegionData = _useUserRegionData.fetchRegionData,
    regionData = _useUserRegionData.regionData,
    clearRegionData = _useUserRegionData.clearRegionData,
    isEndpointUpdated = _useUserRegionData.isEndpointUpdated,
    updateRegionData = _useUserRegionData.updateRegionData,
    isRegionsLoading = _useUserRegionData.isRegionsLoading;
  var hasCleanedStaleSocialLogin = useRef(false);
  var userInitiatedSocialLogin = useRef(false);
  useEffect(function () {
    if (!hasCleanedStaleSocialLogin.current && !userInitiatedSocialLogin.current && isRegionCheckEnabled && regionData !== null && regionData !== void 0 && regionData.socialLoginType && !getAutoLogin()) {
      hasCleanedStaleSocialLogin.current = true;
      updateRegionData({
        socialLoginType: undefined,
        socialSelectedUrl: undefined
      });
    }
  }, [isRegionCheckEnabled, regionData === null || regionData === void 0 ? void 0 : regionData.socialLoginType, updateRegionData]);
  useEffect(function () {
    if (focusTimeoutRef.current) {
      clearTimeout(focusTimeoutRef.current);
    }
    focusTimeoutRef.current = setTimeout(function () {
      if (showOtherSignInForm) {
        var _usernameOtherRef$cur;
        (_usernameOtherRef$cur = usernameOtherRef.current) === null || _usernameOtherRef$cur === void 0 || _usernameOtherRef$cur.focus();
      } else {
        var _usernameRef$current;
        (_usernameRef$current = usernameRef.current) === null || _usernameRef$current === void 0 || _usernameRef$current.focus();
      }
    }, 50);
    return function () {
      if (focusTimeoutRef.current) {
        clearTimeout(focusTimeoutRef.current);
      }
    };
  }, [showOtherSignInForm]);
  useEffect(function () {
    if (isAuthenticated && token && isAuthServiceEnabled) {
      dispatch(authServiceSignIn(token, function () {}));
    }
  }, [token, isAuthenticated, isAuthServiceEnabled, dispatch]);
  var showError = loginData.get('error');
  var showSpinner = loginData.get('waiting') || loginData.get('error') === false;
  useEffect(function () {
    if (pendingSignIn && (regionData === null || regionData === void 0 ? void 0 : regionData.userName) === pendingSignIn.username && isEndpointUpdated) {
      var _username = pendingSignIn.username,
        _password = pendingSignIn.password;
      setPendingSignIn(null);
      handleSignIn(_username, _password);
    }
  }, [regionData, pendingSignIn, isEndpointUpdated, handleSignIn]);
  var getErrorText = function getErrorText(loginData) {
    if (loginData.get('networkFail')) {
      return i18next.t('signin.error.network');
    } else if (loginData.get('loginFail')) {
      return i18next.t('signin.error.credentials');
    }
    if (loginData.get('loginTokenFail')) {
      return i18next.t('signin.error.credentials_expired');
    }
    if (loginData.get('serverFail')) {
      return i18next.t('signin.error.server');
    } else if (loginData.get('userEmailFail')) {
      return i18next.t('signin.error.usernotfound');
    } else if (loginData.get('openidFail')) {
      return i18next.t('signin.error.openid');
    }
    return i18next.t('signin.error.unknown');
  };
  var updateRegionDataSocialLogin = function updateRegionDataSocialLogin(socialLoginType) {
    userInitiatedSocialLogin.current = true;
    updateRegionData(_objectSpread(_objectSpread({}, regionData), {}, {
      socialLoginType: socialLoginType,
      url: regionData === null || regionData === void 0 ? void 0 : regionData.socialSelectedUrl
    }));
  };

  // SSO Functions
  var renderGoogleSignInButton = function renderGoogleSignInButton() {
    if (!startGoogleSignIn) return null;
    return getShouldShowSingleSignOnButton('google') && /*#__PURE__*/_jsxs("div", {
      className: "mb-3",
      children: [/*#__PURE__*/_jsx(ExternalSigninButton, {
        type: "google",
        clickHandler: function clickHandler() {
          updateRegionDataSocialLogin('google');
          startGoogleSignIn();
        }
      }), renderExternalSignInError(SYNC_SOURCE.google)]
    });
  };
  var renderMicrosoftSignInButton = function renderMicrosoftSignInButton() {
    if (!startMicrosoftSignIn) return null;
    return getShouldShowSingleSignOnButton('microsoft') && /*#__PURE__*/_jsxs("div", {
      className: "mb-3",
      children: [/*#__PURE__*/_jsx(ExternalSigninButton, {
        type: "microsoft",
        clickHandler: function clickHandler() {
          updateRegionDataSocialLogin('microsoft');
          startMicrosoftSignIn();
        }
      }), renderExternalSignInError(SYNC_SOURCE.microsoft)]
    });
  };
  var renderOidcSignInButton = function renderOidcSignInButton() {
    if (!setShowOtherSignInForm) return null;
    return getShouldShowSingleSignOnButton('oidc') && /*#__PURE__*/_jsxs("div", {
      className: "mb-3",
      children: [/*#__PURE__*/_jsx(ExternalSigninButton, {
        type: "oidc",
        clickHandler: changeShowOtherSignInForm
      }), renderExternalSignInError(SYNC_SOURCE.oidc)]
    });
  };
  var renderExternalSignInError = function renderExternalSignInError(syncSource) {
    return externalSigninData.get('syncSource') === syncSource && externalSigninData.get('error') && /*#__PURE__*/_jsx("div", {
      className: "mt-2 flex items-center rounded-sm bg-red-100 px-3 py-2 text-sm text-red-600",
      children: /*#__PURE__*/_jsx("span", {
        children: getErrorText(externalSigninData)
      })
    });
  };
  var showSSOButtons = function showSSOButtons() {
    // Inside a Teams tab only Microsoft is offered, through the Teams popup
    // (startTeamsMicrosoftSignIn); the redirect-based sign-ins can't run there.
    if (isTeamsEmbedded) {
      return true;
    }
    if (IS_UAE_HOST && !isUaePassEnabled) {
      return false;
    }
    if (isCtiEmbedded) {
      return true;
    }
    return isElectron() && getHasAnySingleSignOn();
  };
  var renderExternalSignInSection = function renderExternalSignInSection() {
    if (!showSSOButtons()) {
      return null;
    }
    return externalSigninData.get('waiting') ? /*#__PURE__*/_jsx(CancelExternalSigninDialog, {
      onClose: function onClose() {
        userInitiatedSocialLogin.current = false;
        cancelExternalSignIn === null || cancelExternalSignIn === void 0 || cancelExternalSignIn();
      },
      open: true,
      syncSource: externalSigninData.get('syncSource')
    }) : /*#__PURE__*/_jsxs("div", {
      className: "mt-6",
      children: [!isTeamsEmbedded && renderGoogleSignInButton(), renderMicrosoftSignInButton(), !isTeamsEmbedded && renderOidcSignInButton()]
    });
  };
  var renderUaePassSection = function renderUaePassSection() {
    if (!isUaePassEnabled) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: "mt-6",
      children: /*#__PURE__*/_jsx(UaePassSignIn, {
        onFlowActiveChange: setIsUaePassFlowActive
      })
    });
  };
  var renderSignInFooter = function renderSignInFooter() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [tooManyInstances && /*#__PURE__*/_jsx("div", {
        className: "mt-6 rounded-sm bg-yellow-100 px-3 py-2 text-sm text-yellow-800",
        children: i18next.t('signin.form.tooManyInstances')
      }), /*#__PURE__*/_jsx("hr", {
        className: "my-6 w-full border-gray-200"
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex h-12 w-full items-center justify-between",
        children: [isRegionCheckEnabled && showSSOButtons() && /*#__PURE__*/_jsx("div", {
          className: "flex-1 items-start justify-center",
          children: !isRegionsLoading ? /*#__PURE__*/_jsx(UserRegionDropdown, {}) : /*#__PURE__*/_jsx("div", {
            className: "[&>div]:!items-start [&>div]:!self-start",
            children: /*#__PURE__*/_jsx(Loading, {
              size: 16,
              disableTimeout: true
            })
          })
        }), onLanguageChange && !isRegionCheckEnabled && /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(DropdownMenuComponent, {
            title: (localeObject === null || localeObject === void 0 ? void 0 : localeObject.description) || i18next.t('general.language', 'Language'),
            options: languageOptions,
            onItemSelected: onLanguageChange,
            menuButtonClassName: "w-auto bg-transparent"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "flex-1 text-right",
          children: /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "hover:text-main rounded px-2 py-1 text-sm text-gray-600",
            onClick: function onClick() {
              return setShowHelperDialog(true);
            },
            children: i18next.t('signin.helper.help')
          })
        }), showHelperDialog && (IS_UAE_HOST ? /*#__PURE__*/_jsx(SignInHelperDialogEtisalat, {
          open: showHelperDialog,
          handleClose: function handleClose() {
            return setShowHelperDialog(false);
          },
          onLinkClick: onLinkClick
        }) : /*#__PURE__*/_jsx(SignInHelperDialog, {
          open: showHelperDialog,
          handleClose: function handleClose() {
            return setShowHelperDialog(false);
          },
          onLinkClick: onLinkClick
        }))]
      })]
    });
  };
  var displayVersionNotAllowed = function displayVersionNotAllowed() {
    return /*#__PURE__*/_jsxs("div", {
      className: "mb-6 rounded-sm bg-red-100 px-4 py-3 text-red-600",
      children: [/*#__PURE__*/_jsx("div", {
        className: "mb-2 text-base font-semibold",
        children: i18next.t('signin.blacklist.version_expired')
      }), /*#__PURE__*/_jsx("div", {
        className: "text-sm",
        children: i18next.t('signin.blacklist.contact_admin')
      })]
    });
  };

  // OIDC Functions
  var changeShowOtherSignInForm = function changeShowOtherSignInForm() {
    if (showOtherSignInForm && setEnabledOidcSignIn) {
      setEnabledOidcSignIn(true);
    }
    if (setShowOtherSignInForm) {
      setShowOtherSignInForm(!showOtherSignInForm);
      if (isRegionCheckEnabled && clearRegionData) {
        clearRegionData();
      }
    }
    if (onUsernameOtherChanged) {
      onUsernameOtherChanged('');
    }
  };
  var changeEnabledOidcSignIn = useCallback(function (enabled) {
    if (setEnabledOidcSignIn) {
      setEnabledOidcSignIn(enabled);
    }
  }, [setEnabledOidcSignIn]);
  var handleOidcSignIn = useCallback(function (usernameOther) {
    Socialintegration.getAppRegistration({
      onResult: function onResult(appRegistrationId) {
        if (appRegistrationId != null && startOidcSignIn) {
          startOidcSignIn(appRegistrationId);
        } else {
          changeEnabledOidcSignIn(false);
        }
      },
      onError: function onError() {
        changeEnabledOidcSignIn(false);
      },
      onClientError: function onClientError() {
        changeEnabledOidcSignIn(false);
      }
    }, usernameOther);
  }, [startOidcSignIn, changeEnabledOidcSignIn]);
  var prepareOidcSignIn = function prepareOidcSignIn(usernameOther) {
    var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    event === null || event === void 0 || event.preventDefault();
    if (!startOidcSignIn) return;
    var _ref2 = regionData || {},
      userName = _ref2.userName;
    if (isRegionCheckEnabled && usernameOther !== userName) {
      setPendOidcUserName(usernameOther);
      fetchRegionData(usernameOther, true);
    } else {
      handleOidcSignIn(usernameOther);
    }
  };
  useEffect(function () {
    var _ref3 = regionData || {},
      userName = _ref3.userName,
      isOidcLogin = _ref3.isOidcLogin;
    if (pendOidcUserName && userName === pendOidcUserName && isEndpointUpdated && isOidcLogin) {
      handleOidcSignIn(pendOidcUserName);
      setPendOidcUserName(null);
    }
  }, [pendOidcUserName, regionData, isRegionCheckEnabled, fetchRegionData, isEndpointUpdated, handleOidcSignIn]);
  var renderOtherSignInForm = function renderOtherSignInForm() {
    if (!showOtherSignInForm) return null;
    var showSpinner = loginData.get('waiting') || loginData.get('error') === false;
    return /*#__PURE__*/_jsx("div", {
      className: "w-full",
      children: /*#__PURE__*/_jsxs("form", {
        className: "flex w-full flex-col gap-5",
        onSubmit: function onSubmit(event) {
          return enabledOidcSignIn ? prepareOidcSignIn(usernameOther, event) : changeShowOtherSignInForm();
        },
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex justify-start",
          children: /*#__PURE__*/_jsxs("button", {
            type: "button",
            onClick: changeShowOtherSignInForm,
            className: "flex items-center text-gray-600 hover:text-gray-800",
            children: [/*#__PURE__*/_jsx("span", {
              className: "me-2",
              children: "\u2190"
            }), i18next.t('common.back', 'Back')]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "text-center",
          children: /*#__PURE__*/_jsx("h2", {
            className: "text-xl font-semibold",
            children: i18next.t('signin.oidc.enter.username')
          })
        }), /*#__PURE__*/_jsx(BaseInput, {
          id: "username-other",
          autoComplete: "username-other",
          value: usernameOther,
          onChange: function onChange(e) {
            return onUsernameOtherChanged === null || onUsernameOtherChanged === void 0 ? void 0 : onUsernameOtherChanged(e.target.value);
          },
          ref: usernameOtherRef,
          placeholder: i18next.t('signin.email_phone'),
          disabled: !enabledOidcSignIn
        }), externalSigninData.get('waiting') && /*#__PURE__*/_jsx(CancelExternalSigninDialog, {
          onClose: cancelExternalSignIn || function () {},
          open: true,
          syncSource: externalSigninData.get('syncSource')
        }), renderExternalSignInError('oidc'), enabledOidcSignIn ? /*#__PURE__*/_jsx(Button, {
          type: "submit",
          className: "bg-main text-textOnBrand",
          isLoading: showSpinner,
          children: i18next.t('signin.oidc.next')
        }) : /*#__PURE__*/_jsxs("div", {
          className: "text-center",
          children: [/*#__PURE__*/_jsx("div", {
            className: "mb-4 font-semibold",
            children: i18next.t('signin.oidc.no.login.found')
          }), /*#__PURE__*/_jsx(Button, {
            type: "button",
            onClick: changeShowOtherSignInForm,
            className: "bg-gray-500 text-white",
            children: i18next.t('signin.oidc.back')
          })]
        })]
      })
    });
  };
  var userLanguage = i18next.language || 'en';
  var languageOptions = Object.entries(LocalesData).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      code = _ref5[0],
      locale = _ref5[1];
    return {
      key: code,
      label: locale.description
    };
  });
  var localeObject = LocalesData[userLanguage];
  var renderAuthServiceLogin = function renderAuthServiceLogin() {
    return /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [/*#__PURE__*/_jsx("span", {
        className: "bg-yellow absolute top-2 -right-2 rounded-lg px-1.5 py-1 text-[8px] font-bold text-gray-800 uppercase dark:text-white",
        children: 'Testing'
      }), /*#__PURE__*/_jsx("button", {
        className: "bg-main text-textOnBrand mt-4 w-full rounded p-2 text-sm",
        onClick: authLogin,
        "aria-label": i18next.t('signin.authservice.button'),
        "aria-describedby": "authservice-login-button-description",
        children: i18next.t('signin.authservice.button')
      })]
    });
  };
  var handleSignInProcess = useCallback(function (event) {
    var _ref6;
    event.preventDefault();
    userInitiatedSocialLogin.current = false;
    var fullUserName = ((_ref6 = username || (regionData === null || regionData === void 0 ? void 0 : regionData.userName)) === null || _ref6 === void 0 ? void 0 : _ref6.trim()) || '';
    var _ref7 = regionData || {},
      isOidcLogin = _ref7.isOidcLogin,
      userName = _ref7.userName;
    if (isRegionCheckEnabled && fullUserName && fullUserName !== userName && !isOidcLogin) {
      setPendingSignIn({
        username: fullUserName,
        password: password
      });
      fetchRegionData(fullUserName);
    } else {
      handleSignIn(fullUserName, password);
    }
  }, [regionData, username, password, isRegionCheckEnabled, fetchRegionData, handleSignIn]);
  return !isAuthLoading && !isAuthenticated ? /*#__PURE__*/_jsx("div", {
    className: twMerge('flex h-full items-center bg-white px-4', /* UAE Pass owned this screen's dark background before it moved inline. */
    isUaePassEnabled && 'dark:darken-25'),
    children: /*#__PURE__*/_jsxs("div", {
      className: "mx-auto flex w-full max-w-md flex-col",
      children: [!isUaePassFlowActive && /*#__PURE__*/_jsx(BrandLogo, {
        type: "logo48",
        className: "mb-4",
        isPreLogin: true
      }), !allowedVersion && displayVersionNotAllowed(), allowedVersion && showOtherSignInForm && renderOtherSignInForm(), allowedVersion && !showOtherSignInForm && /*#__PURE__*/_jsxs(_Fragment, {
        children: [!isUaePassFlowActive && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("form", {
            className: "flex w-full flex-col gap-5",
            onSubmit: handleSignInProcess,
            children: [/*#__PURE__*/_jsx(BaseInput, {
              id: "username",
              autoComplete: "username",
              value: username || (regionData === null || regionData === void 0 ? void 0 : regionData.userName),
              onChange: function onChange(e) {
                var newUserName = e.target.value;
                onUsernameChanged(newUserName);
                if (regionData && newUserName !== (regionData === null || regionData === void 0 ? void 0 : regionData.userName)) {
                  clearRegionData();
                }
              },
              ref: usernameRef,
              placeholder: i18next.t('signin.email_phone')
            }), /*#__PURE__*/_jsx(BaseInput, {
              id: "password",
              type: "password",
              autoComplete: "current-password",
              value: password,
              onChange: function onChange(e) {
                return onPasswordChanged(e.target.value);
              },
              placeholder: i18next.t('signin.password')
            }), showError && /*#__PURE__*/_jsx("div", {
              className: "text-red mt-1 rounded-sm bg-red-100 px-3 py-2 text-sm",
              children: getErrorText(loginData)
            }), /*#__PURE__*/_jsx("div", {
              className: "flex justify-between",
              children: passwordUrl && /*#__PURE__*/_jsx("a", {
                href: passwordUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: onLinkClick,
                className: "text-sm text-blue-800 hover:underline dark:text-blue-500",
                children: i18next.t('signin.forgot_password')
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "submit",
              className: "bg-main text-textOnBrand",
              isLoading: showSpinner,
              children: i18next.t('signin.signin')
            })]
          }), isAuthServiceEnabled && renderAuthServiceLogin(), renderExternalSignInSection()]
        }), renderUaePassSection(), !isUaePassFlowActive && renderSignInFooter()]
      })]
    })
  }) : /*#__PURE__*/_jsx(Loading, {
    size: 64
  });
};
export default SignInForm;